__turbopack_context__.v({
  "className": "noto_sans_bengali_441c4a4-module__FRlfVq__className",
});
